import React, { useState, useCallback } from "react";
import { 
  SuccessMessage,
  FailMessage,
  Loading,
  FormatValueToDecimal,
  CompanySelect,
  FormatDateToWord,
  YearSelect,
  MonthSelect
} from "../../common/APICommon";
import { apiUrl } from "../../utils/Configuration";
import axios from 'axios';
import ExcelJS from 'exceljs';
import { PDFDocument } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
import NoAccess from "../NoAccess";
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import RestartAltIcon from '@mui/icons-material/RestartAlt';

export default function WorkingTrialBalance() {
//#region Others
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
//#endregion






//#region Variables 
  const [company, setCompany] = useState(null);
  // const today = new Date().toISOString().split("T")[0];
  const [monthFrom, setMonthFrom] = useState(null);
  const [monthTo, setMonthTo] = useState(null);
  const [year, setYear] = useState(null);
//#endregion






//#region Generate
  const fetchReportData = useCallback(async () => {
    const body = {
      monthFrom: monthFrom,
      monthTo: monthTo,
      year: year,
    }

    try {
      // const response = await axios.post(`${apiUrl}/api/Report/report-data/statement-of-account`, body, {
      const response = await axios.post(`${apiUrl}/api/Report/report-data/working-trial-balance`, body, {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return null
    }
  }, [monthFrom, monthTo, year]);

  // PDF
  const generateWorkingTrialBalance = async () => {
      if (!monthFrom || !monthTo || !year || !company) {
        setFailMessage("Please fill up all fields");
        return;
      }
  
      setLoading(true);
      const allData = await fetchReportData();
      const _data = allData;
  
      if (!_data || _data?.length <= 0) {
        setFailMessage("No record found");
        setLoading(false);
        return;
      }
  
      try {
        const pdfUrl = `${window.location.origin}/docs/WORKING_TRIAL_BALANCE.pdf`;
        const templateBytes = await fetch(pdfUrl).then((r) => r.arrayBuffer());
        const templateDoc = await PDFDocument.load(templateBytes);
        
        const response = await fetch(pdfUrl);
        const pdfBytes = await response.arrayBuffer();
        const pdfDoc = await PDFDocument.load(pdfBytes);
  
        pdfDoc.registerFontkit(fontkit);
        const fontResponse = await fetch("/calibri.ttf");
        const fontBytes = await fontResponse.arrayBuffer();
        const calibriFont = await pdfDoc.embedFont(fontBytes);
  
        const boldResponse = await fetch("/calibrib.ttf");
        const boldBytes = await boldResponse.arrayBuffer();
        const calibriBold = await pdfDoc.embedFont(boldBytes);
  
        const truncateText = (text, maxWidth, font, fontSize) => {
          if (!text) return "";
          let currentWidth = font.widthOfTextAtSize(text, fontSize);
          if (currentWidth <= maxWidth) return text;
          const ellipsis = "...";
          let truncated = text;
          while (truncated.length > 0 && font.widthOfTextAtSize(truncated + ellipsis, fontSize) > maxWidth) {
            truncated = truncated.slice(0, -1);
          }
          return truncated + ellipsis;
        };
  
        const drawHeader = (targetPage) => {
          targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 583, size: 16, font: calibriBold });
          targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 573, size: 8, font: calibriFont });
          targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 563, size: 8, font: calibriFont });
  
          targetPage.drawText(`${monthFrom} to ${monthTo}`, { x: 83, y: 506, size: 8, font: calibriFont });
          targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 495, size: 8, font: calibriFont });
        };
  
        let pages = pdfDoc.getPages();
        let currentPage = pages[0];
        drawHeader(currentPage);
  
        let yPosition = 446;
        const bottomThreshold = 80;
        const lineHeight = 12;
  
        let grandJanuary = 0;
        let grandFebruary = 0;
        let grandMarch = 0;
        let grandApril = 0;
        let grandMay = 0;
        let grandJune = 0;
        let grandJuly = 0;
        let grandAugust = 0;
        let grandSeptember = 0;
        let grandOctober = 0;
        let grandNovember = 0;
        let grandDecember = 0;
  
        // Helper to handle page breaks
        const addNewPage = async () => {
          const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
          currentPage = pdfDoc.addPage(templatePage);
          drawHeader(currentPage);
          yPosition = 446;
        };
  
        for (const record of _data) {
          // --- PAGE BREAK CHECK FOR ITEM ROW ---
          if (yPosition - lineHeight < bottomThreshold) {
            await addNewPage();
          }

          // Draw Row Data
          // currentPage.drawText(FormatDateToMDY(order.date), { x: 35, y: yPosition, size: 8, font: calibriFont });
          const truncatedAccount = truncateText(record?.glAccountName ?? "", 120, calibriFont, 8);
          currentPage.drawText(truncatedAccount, { x: 40, y: yPosition, size: 8, font: calibriFont });

          currentPage.drawText(`${FormatValueToDecimal(record.january)}`, { x: 200, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(record.february)}`, { x: 245, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(record.march)}`, { x: 295, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(record.april)}`, { x: 340, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(record.may)}`, { x: 384, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(record.june)}`, { x: 430, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(record.july)}`, { x: 474, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(record.august)}`, { x: 520, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(record.september)}`, { x: 570, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(record.october)}`, { x: 619, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(record.november)}`, { x: 669, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(record.december)}`, { x: 720, y: yPosition, size: 8, font: calibriFont });

          yPosition -= lineHeight;
          grandJanuary += record.january;
          grandFebruary += record.february;
          grandMarch += record.march;
          grandApril += record.april;
          grandMay += record.may;
          grandJune += record.june;
          grandJuly += record.july;
          grandAugust += record.august;
          grandSeptember += record.september;
          grandOctober += record.october;
          grandNovember += record.november;
          grandDecember += record.december;
        }
  
        // --- FOOTER SECTION (GRAND TOTAL) ---
        if (yPosition < 100) {
          await addNewPage();
        }
  
        currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 1 });
        yPosition -= 15;
        currentPage.drawText(`Grand Total:  `, { x: 35, y: yPosition, size: 9, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(grandJanuary)}`, { x: 200, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(grandFebruary)}`, { x: 245, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(grandMarch)}`, { x: 295, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(grandApril)}`, { x: 340, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(grandMay)}`, { x: 384, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(grandJune)}`, { x: 430, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(grandJuly)}`, { x: 474, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(grandAugust)}`, { x: 520, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(grandSeptember)}`, { x: 570, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(grandOctober)}`, { x: 619, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(grandNovember)}`, { x: 669, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(grandDecember)}`, { x: 720, y: yPosition, size: 8, font: calibriFont });
  
        // --- PAGINATION ---
        const allPages = pdfDoc.getPages();
        const totalPages = allPages.length;
        allPages.forEach((page, index) => {
          page.drawText(`Page ${index + 1} of ${totalPages}`, {
            x: 680,
            y: 580,
            size: 10,
            font: calibriBold,
          });
        });
  
        const modifiedPdfBytes = await pdfDoc.save();
        const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = `WORKING_TRIAL_BALANCE.pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
  
      } catch (error) {
        console.error("Error:", error);
        setFailMessage("Error processing PDF");
      }
      setLoading(false);
  };

  const exportWorkingTrialBalanceExcel = async () => {
    if (!monthFrom || !monthTo || !year || !company) {
      setFailMessage("Please fill up all fields");
      return;
    }

    setLoading(true);

    try {
      const allData = await fetchReportData();
      const _data = allData;

      if (!_data || _data?.length <= 0) {
        setFailMessage("No record found");
        setLoading(false);
        return;
      }

      // 1. Create Workbook and Worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Working Trial Balance');

      // 2. Add Company Header Information
      worksheet.addRow([company.name?.toUpperCase()]).font = { bold: true, size: 14 };
      worksheet.addRow([company.address]);
      worksheet.addRow([`TIN: ${company.tin}`]);
      worksheet.addRow([]); // Gap

      // 3. Add Report Title and Filters
      worksheet.addRow(['WORKING TRIAL BALANCE']).font = { bold: true, size: 12 };
      worksheet.addRow([`Period: ${monthFrom} to ${monthTo} ${year}`]);
      worksheet.addRow([`Date Printed: ${FormatDateToWord(new Date())}`]);
      worksheet.addRow([]); // Gap

      // 4. Define Table Columns
      const headerRow = worksheet.addRow([
        'Account Name',
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ]);

      // Style the Header Row
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFF' } };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '444444' } };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
        cell.border = { 
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' } 
        };
      });

      // 5. Add Data Rows
      let totals = {
        jan: 0, feb: 0, mar: 0, apr: 0, may: 0, jun: 0,
        jul: 0, aug: 0, sep: 0, oct: 0, nov: 0, dec: 0
      };

      _data.forEach(record => {
        const row = worksheet.addRow([
          record.glAccountName ?? "N/A",
          parseFloat(record.january || 0),
          parseFloat(record.february || 0),
          parseFloat(record.march || 0),
          parseFloat(record.april || 0),
          parseFloat(record.may || 0),
          parseFloat(record.june || 0),
          parseFloat(record.july || 0),
          parseFloat(record.august || 0),
          parseFloat(record.september || 0),
          parseFloat(record.october || 0),
          parseFloat(record.november || 0),
          parseFloat(record.december || 0),
        ]);

        // Numeric formatting for columns B to M (index 2 to 13)
        for (let i = 2; i <= 13; i++) {
          row.getCell(i).numFmt = '#,##0.00';
        }

        // Accumulate Grand Totals
        totals.jan += (record.january || 0);
        totals.feb += (record.february || 0);
        totals.mar += (record.march || 0);
        totals.apr += (record.april || 0);
        totals.may += (record.may || 0);
        totals.jun += (record.june || 0);
        totals.jul += (record.july || 0);
        totals.aug += (record.august || 0);
        totals.sep += (record.september || 0);
        totals.oct += (record.october || 0);
        totals.nov += (record.november || 0);
        totals.dec += (record.december || 0);
      });

      // 6. Grand Totals Footer Row
      const grandTotalRow = worksheet.addRow([
        'GRAND TOTAL',
        totals.jan, totals.feb, totals.mar, totals.apr, totals.may, totals.jun,
        totals.jul, totals.aug, totals.sep, totals.oct, totals.nov, totals.dec
      ]);

      grandTotalRow.font = { bold: true };
      // Style and Format Grand Total numeric cells
      for (let i = 2; i <= 13; i++) {
        const cell = grandTotalRow.getCell(i);
        cell.numFmt = '#,##0.00';
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } }; // Yellow highlight
        cell.border = { 
          top: { style: 'thin' }, 
          bottom: { style: 'double' } 
        };
      }

      // 7. Adjust Column Widths
      worksheet.columns = [
        { width: 35 }, // Account Name
        { width: 12 }, // Jan
        { width: 12 }, // Feb
        { width: 12 }, // Mar
        { width: 12 }, // Apr
        { width: 12 }, // May
        { width: 12 }, // Jun
        { width: 12 }, // Jul
        { width: 12 }, // Aug
        { width: 12 }, // Sep
        { width: 12 }, // Oct
        { width: 12 }, // Nov
        { width: 12 }, // Dec
      ];

      // 8. Generate and Download
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const filename = `Working_Trial_Balance_${year}_${new Date().getTime()}.xlsx`;
      
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);

    } catch (error) {
      console.error("Excel Error:", error);
      setFailMessage("Error generating Excel file");
    }

    setLoading(false);
  };
//#endregion






//#region Access Template
  const accountData = JSON.parse(localStorage.getItem("accountData"));
  
  if (!accountData?.accessTemplate?.hasWorkingTrialBalance) {
    return <NoAccess />;
  }
//#endregion






//#region UI
  return (
    <>
      <div className="p-6 bg-gray-50 min-h-screen">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
          <div>
            <h2 className="text-3xl font-bold text-gray-800 flex items-center gap-2">
              <HistoryEduIcon fontSize="large" className="text-theme-color" />
              {`Working Trial Balance`}
            </h2>
            <p className="text-gray-500 mt-1">Balances of all General Ledger (GL) accounts.</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Company <span className="text-red-500">*</span>
            </label>
            <CompanySelect data={company} setData={setCompany} isEditable={true}/>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Year
            </label>
            <YearSelect data={year} setData={setYear} isEditable={true}/>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Month From
            </label>
            <MonthSelect data={monthFrom} setData={setMonthFrom} isEditable={true}/>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Month To
            </label>
            <MonthSelect data={monthTo} setData={setMonthTo} isEditable={true}/>
          </div>

        </div>

        <div className="mt-5 p-6 bg-white rounded-2xl shadow-sm border border-gray-100">
          <h2 className="text-lg font-bold text-gray-800 mb-6 px-2">Generate Reports</h2>

          {/* Header Row - Hidden on Mobile */}
          <div className="hidden md:grid grid-cols-12 gap-4 px-4 mb-2 text-xs font-black uppercase tracking-widest text-gray-400">
            <div className="col-span-2">Report Category</div>
            <div className="col-span-5">PDF Reports</div>
            <div className="col-span-5 border-l border-gray-100">Excel Reports</div>
          </div>

          <div className="space-y-3">
            {[
              { 
                label: "Summary", 
                pdf_summarized: generateWorkingTrialBalance, 
                excel_summarized: exportWorkingTrialBalanceExcel, // Replace with your Excel function
              },
            ].map((group, idx) => (
              <div key={idx} className="grid grid-cols-1 md:grid-cols-12 items-center gap-4 p-4 rounded-xl border border-gray-100 hover:bg-gray-50 transition-colors">
                
                {/* Label */}
                <div className="col-span-2">
                  <span className="text-sm font-bold text-gray-700">{group.label}</span>
                </div>

                {/* PDF Column */}
                <div className="col-span-5 flex flex-wrap gap-2">
                  {group.pdf_detailed &&
                    <button 
                      onClick={group.pdf_detailed} 
                      className="flex items-center gap-2 bg-red-50 text-red-700 border border-red-100 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-red-100 transition-all active:scale-95"
                      title="Download PDF Detailed"
                    >
                      <RestartAltIcon sx={{ fontSize: 16 }} /> Detailed
                    </button>
                  }
                  
                  {group.pdf_summarized &&
                    <button 
                      onClick={group.pdf_summarized} 
                      className="flex items-center gap-2 bg-white text-gray-700 border border-gray-300 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-gray-50 transition-all active:scale-95"
                    >
                      Summarized
                    </button>
                  }

                  {group.pdf_extra && (
                    <button 
                      onClick={group.pdf_extra} 
                      className="flex items-center gap-2 bg-blue-50 text-blue-700 border border-blue-100 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-blue-100 transition-all active:scale-95"
                    >
                      Summarized w/ %
                    </button>
                  )}
                </div>

                {/* Excel Column */}
                <div className="col-span-5 flex flex-wrap gap-2 border-t md:border-t-0 md:border-l border-gray-100 pt-3 md:pt-0">
                  {group.excel_detailed &&
                    <button 
                      onClick={group.excel_detailed} 
                      className="flex items-center gap-2 bg-green-600 text-white px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-green-700 shadow-sm transition-all active:scale-95"
                    >
                      Excel Detailed
                    </button>
                  }
                  
                  {group.excel_summarized &&
                    <button 
                      onClick={group.excel_summarized} 
                      className="flex items-center gap-2 bg-green-50 text-green-700 border border-green-200 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-green-100 transition-all active:scale-95"
                    >
                      Excel Summ.
                    </button>
                  }
                  
                  
                  { group.excel_extra &&
                    <button 
                      onClick={group.excel_extra} 
                      className="flex items-center gap-2 bg-green-50 text-green-700 border border-green-200 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-green-100 transition-all active:scale-95"
                    >
                      Excel Summ. w/ %
                    </button>
                  }
                </div>

              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
//#endregion
}